/**
 * 32×32 논리 해상도 픽셀 캐릭터 시스템 스펙.
 * 모든 파츠 PNG는 동일한 캔버스(32×32)로 내보내고, 투명 영역은 동일하게 유지합니다.
 */

/** 논리 픽셀 단위 캔버스 크기 (전신 타일형) */
export const CHARACTER_CANVAS_WIDTH = 32;
export const CHARACTER_CANVAS_HEIGHT = 32;

/**
 * 앵커: 스프라이트 하단 중앙이 박스의 (16, 31) 근처에 오도록 제작하는 것을 권장합니다.
 * (발바닥 기준 정렬 — LayeredCharacter는 박스 전체를 같은 origin으로 쌓습니다.)
 */
export const CHARACTER_ANCHOR_NOTE =
  '파츠 제작 시 캐릭터 실루엣이 32×32 프레임 안에서 같은 위치에 오도록 맞춥니다.';

/** 화면에 그릴 때 아래에서 위로 쌓는 순서 (앞쪽이 나중) */
export const CHARACTER_LAYER_RENDER_ORDER = [
  'background',
  'base',
  'bottom',
  'top',
  'hair',
  'face',
  'hat',
  'accessory',
  'accessoryFront'
] as const;

export type CharacterLayerSlot = (typeof CHARACTER_LAYER_RENDER_ORDER)[number];

export type CharacterLoadout = Partial<Record<CharacterLayerSlot, string | null>>;

/** 캐릭터 능력치 (1~10, 교사·관리 화면에서 조정 가능). Firestore 필드명과 동일 */
export const CHARACTER_STAT_KEYS = ['atk', 'def', 'hp', 'mp'] as const;
export type CharacterStatKey = (typeof CHARACTER_STAT_KEYS)[number];

export type CharacterStats = Record<CharacterStatKey, number>;

export const DEFAULT_CHARACTER_STATS: CharacterStats = {
  atk: 5,
  def: 5,
  hp: 5,
  mp: 5,
};

/** UI 표시용 라벨 */
export const CHARACTER_STAT_LABELS: Record<CharacterStatKey, string> = {
  atk: 'ATK',
  def: 'DEF',
  hp: 'HP',
  mp: 'MP',
};

/** 캐릭터 레벨 (방치형 RPG 등, 학급 학생 문서 characterLevel) */
export const CHARACTER_LEVEL_MIN = 1;
export const CHARACTER_LEVEL_MAX = 99;
export const DEFAULT_CHARACTER_LEVEL = 1;
